import { post, postAsyncV2 } from "./apiManager";

export const getPatientsList = (
  phoneNumber,
  onSuccess,
  onFailed,
  onComplete
) => {
  post(
    `Patient/GetPatient`,
    {
      Mobile: phoneNumber,
    },
    "getPatientList",
    onSuccess,
    onFailed,
    onComplete
  );
};

export const getPatientsListV2 = async (phoneNumber) => {
  const response = await postAsyncV2("Patient/GetPatient", {
    Mobile: phoneNumber,
  });
  const data = await response.json();
  const patientList = data.data;
  return patientList;
};

export const newPatient = (
  title,
  firstName,
  lastName,
  address,
  mobileNo,
  nicNo,
  birthday,
  gender,
  onSuccess,
  onFailed,
  onComplete
) => {
  fetch(`${process.env.REACT_APP_BASE_URL_V3}Patient/Save`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Address: { Id: 0, AddressLine1: address },
      DateOfBirth: birthday,
      FirstName: firstName,
      Gender: gender,
      Id: 0,
      LastName: lastName,
      MaritalStatus: 2,
      Mobile: mobileNo,
      NIC: nicNo,
      Occupation: "",
      ParentId: null,
      PatientTypeId: null,
      Title: title,
      BloodGroup: null,
      Passport: null,
      UserSaved: "2",
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      onSuccess(data);
    })
    .catch((error) => {
      console.error("Error:", error);
      onFailed();
    })
};

export const getPatientById = (
  id,
  onSuccess = () => {},
  onFailed = () => {}
) => {
  fetch(`${process.env.REACT_APP_BASE_URL_V3}Patient/GetPatient`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Id: id,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      onSuccess(data);
    })
    .catch((error) => {
      console.error("Error:", error);
      onFailed();
    });
};
